/* eslint-disable tailwindcss/no-custom-classname */

import { observer } from 'mobx-react-lite';
import type { NextPage } from 'next';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

import AuthContainer from '@/components/auth/AuthContainer/AuthContainer';
import { Meta } from '@/layouts/Meta';
import { initializeStore, useStore } from '@/models/root-store';
import type { SeoData } from '@/shared/types';
import { Main } from '@/templates/Main';
import { getGeneralPageSeoData } from '@/utils/api-helpers';

type SignInProps = {
  seoData: SeoData;
};

const SignIn: NextPage<SignInProps> = observer(({ seoData }: SignInProps) => {
  const {
    cartStore: { cart },
  } = useStore();
  const router = useRouter();
  const { error } = router.query;

  // Handle redirect to this page with error message
  useEffect(() => {
    if (error) {
      toast.error(`${error}`);
    }
  }, [error]);

  useEffect(() => {
    cart.closeCart();
  }, []);

  return (
    <Main
      meta={
        <Meta
          title={seoData?.seoTitle || 'Sign In'}
          description={seoData?.seoDescription || 'Sign In'}
          canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/signin`}
        />
      }
      seoBlurb={seoData?.seoBlurb}
    >
      <div className="mb-[72px] mt-[26px] flex flex-col items-center justify-center lg:mb-[112px] lg:mt-[32px] lg:flex-row">
        <AuthContainer navigatedFrom="loginpage" />
      </div>
    </Main>
  );
});

export async function getStaticProps() {
  const store = initializeStore({ ssr: true });
  const seoData: SeoData = await getGeneralPageSeoData(store, 'signin');

  return {
    props: {
      seoData,
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: false,
  };
}

export default SignIn;
